<template>
  <div class="module-home">
    <NavComponent></NavComponent>
    <div class="container">
      <div class="slogan">
        <div class="sologan-info" @click="goRelationPage">短视频营销平台及赋能方案供应商</div>
        <div class="product d-none d-md-block">
          <img draggable="false" src="../assets/lp1.png" alt="">
          <img draggable="false" src="../assets/lp2.png" alt="">
          <img draggable="false" src="../assets/lp3.png" alt="">
          <img draggable="false" src="../assets/lp4.png" alt="">
        </div>

        <div id="carouselExampleIndicators" class="carousel slide d-md-none pics" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src="../assets/lp1.png" alt="">
            </div>
            <div class="carousel-item">
              <img src="../assets/lp2.png" alt="">
            </div>
            <div class="carousel-item">
              <img src="../assets/lp3.png" alt="">
            </div>
            <div class="carousel-item">
              <img src="../assets/lp4.png" alt="">
            </div>
          </div>
        </div>  

        <div class="min_box carousel slide d-md-none pics">
          <div class="min_project">
            <img :src="miniProject" class="mini_img" alt="">
            <div class="min_info">秘邻小程序</div>
          </div>
          <div class="min_project">
            <img :src="miniProjectS" class="mini_img" alt="">
            <div class="min_info">秘邻公众号</div>
          </div>
        </div>  

        <div class="carousel slide d-md-none pics">
          <div class="down_load_box">
            <div class="down_load" @click="goDownLoadPage(1)">应用宝下载</div>
            <div class="down_load_s" @click="goDownLoadPage(2)">官网下载</div>
          </div>
          <!-- <div class="open_wx_app" @click="goRelationPage">
            观看视频
          </div> -->
          <openWeapp></openWeapp>
        </div> 
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import miniProject from '../assets/mini_project.png'
import miniProjectS from '../assets/mini_project2.png'
import NavComponent from '@/components/header.vue'
import FooterComponent from '@/components/footer.vue'
import util from "../util/util.js";
import openWeapp from "../components/openWeapp"
export default {
  components: {
    NavComponent,
    FooterComponent,
    openWeapp
  },
  data () {
    return {
      miniProject,
      miniProjectS,
      downLoadUrl: ''
    }
  },
  mounted(){
    // this.axios({
    //   method: "GET",
    //   url: "/feeds/version/downloadUrl",
    //   headers: {
    //     "Authorization": 'Bearer' + 'sss'
    //   }
    // }).then((res) => {
    //   console.log(res,'res')
    //   if(res.data && res.data.code == 0){
    //     this.downLoadUrl = res.data.data;
    //     console.log(this.downLoadUrl)
    //   }
    // }).catch((err) => {
    //   console.log("err",err)
    // })
  },
  methods: {
    goRelationPage(){
        util.goContact();
    },
    downLoadApp(){
      var src = this.downLoadUrl;
      console.log(src);
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = "javascript: '<script>location.href=\"" + src + "\"<\/script>'";
      document.getElementsByTagName('body')[0].appendChild(iframe);
    },
    goDownLoadPage(type){
        if(type == 1){
            window.open("https://a.app.qq.com/o/simple.jsp?pkgname=com.thepixel.client.android")
        } else if(type == 2){
            window.open("https://apk.milinzone.com/milin.apk","_self")
        }
    }
  }
}
</script>

<style lang="scss" scoped>
  .down-load{
    position: relative;
    z-index: 100;
  }
  .module-home {
    height: 933px;
    background: url('../assets/bg.jpg') center bottom no-repeat;
    text-align: center;
    .pics {
      margin-top: 40px;
    }
    .carousel-indicators li {
      height: 5px;
      background-color: #f2f2f2;
    }
    .carousel {
      width: 100%;
      position: relative;
      img {
        width: 60%;
        max-width: 250px;
      }
    }
    .slogan {
      margin-top: 130px;
    }

    .slogan-img {
      width: 100%;
      max-width: 333px;
    }

    .sologan-info{
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      line-height: 50px;
      color: #07C160;
      cursor: pointer;
    }

    .product {
      margin-top: 50px;
      font-size: 0;
      line-height: 0;
      padding-bottom: 20px;
      img {
        margin: 0 10px;
        width: 200px;
      }
    }
    .wx {
      margin-right: 10px;
      vertical-align: top;
    }
    .download {
      margin-top: 3rem;
    }
    .d-btn {
      vertical-align: top;
      border: 1px solid #000;
      border-radius: 4px;
      padding: 2px 5px;
      font-size: .75rem;
      text-align: left;
      margin-top: 5px;
      cursor: pointer;
      transition: background .25s ease;

      &:hover {
        background: #07C160;
        a {
          color: #fff;
        }
      }

      a {
        color: #333;
      }

      img {
        width: 25px;
        height: 25px;
      }
    }

    @media screen and(max-width: 768px) {
      & {
        height: 40rem;
        .sologan-info{
          font-size: 1rem;
        }
        .slogan {
          margin-top: 50px;
        }
        .min_box{
          height: 98px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 75px;
          .min_project{
            height: 100%;
            width: 74px;
            .mini_img{
              height: 74px;
              width: 74px;
            }
            .min_info{
              margin-top: 10px;
              line-height: 12px;
              font-size: 12px;
              color: #0F0E0E;
              font-weight: 500;
            }
            &:nth-child(1){
              margin-right: 45px;
            }
          }
        }
        .down_load_box{
          width:100%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          .down_load,.down_load_s{
            width: 100px;
            height: 40px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            background: #07C160;
          }
          .down_load_s{
            margin-left: 10px;
          }
        }
        .open_wx_app{
          width: 100px;
          height: 40px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          background: #07C160;
          margin: 0 auto;
        }
      }
    }

    .carousel-indicators {
        bottom: -3rem;
    }
  }
</style>
